module.exports = __webpack_public_path__ + "9b7997fe5662e5abf2b1d268e5b9dbf2.jpg";